import { canv } from '@/canv/global.js'
import { toolBase } from '@/tools/toolBase';

import { matrixTranslate } from '@/canv/utils.js';
import { rafThrottle } from "@/helpers/rafThrottle";
import { eventEmitter } from "@/eventEmitter";


export class dragTool extends toolBase {

    constructor() {
        super();
    }

    getToolTipName() {
        return "Рука";
    }

    select() {
        this.isSelected = true;
        this.changeCursor();
    }

    unselect() {
        this.isSelected = false;
        this.changeCursor();
    }

    changeCursor() {
        const canvas = document.getElementsByTagName('canvas');

        if (this.isSelected) {
            canvas[0].classList.add('grabble');
        } else {
            canvas[0].classList.remove('grabble');
        }
    }

    updateMinimap = rafThrottle(() => {
        eventEmitter.dispatch("minimap.update", { needUpdate: true });
    });

    TryAction(type) {
        if (type == "mousedown") {

            this.mouseDown = true;

        } else if (type == "mousemove") {

            if (!this.mouseDown) {
                return;
            }

            if (canv.actionManager.lastMoveEvt.pointerType === "mouse") {
                const evt = canv.actionManager.lastMoveEvt;
                matrixTranslate(evt.movementX * canv.dpr, evt.movementY * canv.dpr);
            } else if (canv.actionManager.lastTouches.length >= 1 && canv.actionManager.prevTouches.length >= 1) {
                const dx = canv.actionManager.lastTouches[0].clientX - canv.actionManager.prevTouches[0].clientX;
                const dy = canv.actionManager.lastTouches[0].clientY - canv.actionManager.prevTouches[0].clientY;
                matrixTranslate(dx * canv.dpr, dy * canv.dpr);
            }

            canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
            this.updateMinimap();

            canv.redraw();

        } else if (type == "mouseup") {

            this.mouseDown = false;
            eventEmitter.dispatch("minimap.update", { needUpdate: true });

        }

        canv.redraw();
    }


    draw() {

    }

    isSelected = false;
    name = "dragTool";
    mouseDown = false;

}
